import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'gatsby';
import {NavItem} from '@src/components/Nav';

import DropdownMenu from '@src/components/Nav/DropdownMenu';
import DropdownMenuItem from '@src/components/Nav/DropdownMenuItem';

import * as styles from './mobileMenu.module.scss';

import type {Translations} from '@src/i18n';
import Button from '@src/components/Button';

interface MobileMenuProps {
  closeMenu: () => Promise<any>;
  nav: NavItem[];
}

const MobileMenu = ({closeMenu, nav}: MobileMenuProps) => {
  const {t} = useTranslation('Nav');

  return (
    <div className={styles.content}>
      <Link className={styles.loginButton} to="https://my.devoted.com/">
        <Button size="medium" text={t('memberLogin')} theme="primary" />
      </Link>
      <ul className={styles.list}>
        <MobileMenuItems nav={nav} />
        <li className={styles.listItem}>
          <Link className={styles.link} to={t('links.providers.url')}>
            {t('links.providers.text')}
          </Link>
        </li>
        <li className={styles.listItem}>
          <Link className={styles.link} to={t('links.brokers.url')}>
            {t('links.brokers.text')}
          </Link>
        </li>
      </ul>
      <div className={styles.utility}>
        <ul className={styles.utilityList}>
          <li className={styles.utilityItem}>
            <div className="gtm-callus-default">
              <span className={styles.title}>{t('callUs.mobile')}</span>
              <a
                className={styles.phoneNumber}
                href={`tel:${t('callUs.number')}`}>
                {t('callUs.number')}
                <span> TTY 711</span>
              </a>
            </div>
            <div className="gtm-callus-direct">
              <span className={styles.title}>{t('callUsDirect.mobile')}</span>
              <a
                className={styles.phoneNumber}
                href={`tel:${t('callUsDirect.number')}`}>
                {t('callUsDirect.number')}
                <span> TTY 711</span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

interface MobileMenuItemsProps {
  nav: NavItem[];
}

const MobileMenuItems: React.FC<MobileMenuItemsProps> = ({nav}) => {
  const [isOpen, setIsOpen] = React.useState<boolean[]>([]);
  const setIsOpenFor = (i: number) => (v: boolean) => {
    // simple toggle, allow multiple menus to be open at the same time
    const newIsOpen = [...isOpen];
    newIsOpen[i] = v;

    setIsOpen(newIsOpen);
  };

  return (
    <>
      {nav?.map(({primary, items}: NavItem, i) => (
        <li key={i} className={styles.listItem}>
          {items.length ? (
            <DropdownMenu
              isOpen={Boolean(isOpen[i])}
              setIsOpen={setIsOpenFor(i)}
              title={primary.label.text}>
              <ul role="menu">
                {items.map((item, idx) => (
                  <li key={idx}>
                    <DropdownMenuItem item={item} />
                  </li>
                ))}
              </ul>
            </DropdownMenu>
          ) : (
            <Link className={styles.link} to={primary.link.text}>
              {primary.label.text}
            </Link>
          )}
        </li>
      ))}
    </>
  );
};

export default MobileMenu;
